export interface CookieConsentCategories {
  statistics: boolean;
  marketing: boolean;
}

export interface CookieConsent {
  acceptAt: number;
  categories: CookieConsentCategories;
  changedAt: number;
}

export enum CookiesDtoStage {
  INIT,
  CHANGE,
}

export interface CookiesDto {
  /** bits compressed into value */
  list: number;
  /** last change at */
  decided_at: number;
  stage: CookiesDtoStage;
}
